export const ccToPcConverter = cc => {
  let ccArr = cc.split('');
  let pcArr = ccArr.map((letter, index) => {
    if (ccArr[index].charCodeAt(0) >= 65 && ccArr[index].charCodeAt(0) <= 90) {
      return ` ${letter}`;
    } else if (index === 0) {
      return `${letter.toUpperCase()}`;
    } else {
      return `${letter}`;
    }
  });
  let pc = pcArr.join('');
  let updatedPc = pc.split(' ').map(data => {
    if (data === 'Id') {
      return data.toUpperCase();
    } else {
      return data;
    }
  });
  return updatedPc.join(' ');
};

export const getFilteredList = (list, keysToFilter) => {
  return Object.keys(list)
  .filter(key => keysToFilter.includes(key))
  .reduce((result, key) => {
    result[key] = list[key];
    return result;
  }, {});
}